// // Doctors Page - Display doctor profiles
// import { useState, useEffect } from "react";
// import { Card } from "@/components/ui/card";
// import { Badge } from "@/components/ui/badge";
// import { Button } from "@/components/ui/button";
// import { Input } from "@/components/ui/input";
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
// import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
// import ConsultationModal from "@/components/ConsultationModal";
// import { Search, Stethoscope, Building2, Clock, Globe, Award, Calendar, Phone } from "lucide-react";
// import axios from "axios";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const SPECIALIZATIONS = [
//   "All Specializations",
//   "Cardiology",
//   "Orthopedics",
//   "Oncology",
//   "Neurology",
//   "Transplant",
//   "Dental",
//   "Cosmetic Surgery",
//   "Fertility",
//   "Eye Care",
//   "General Surgery"
// ];

// export default function DoctorsPage() {
//   const [doctors, setDoctors] = useState([]);
//   const [filteredDoctors, setFilteredDoctors] = useState([]);
//   const [search, setSearch] = useState("");
//   const [specialization, setSpecialization] = useState("All Specializations");
//   const [loading, setLoading] = useState(true);
//   const [selectedDoctor, setSelectedDoctor] = useState(null);

//   useEffect(() => {
//     axios.get(`${API}/doctors`)
//       .then(r => {
//         setDoctors(r.data);
//         setFilteredDoctors(r.data);
//       })
//       .catch(console.error)
//       .finally(() => setLoading(false));
//   }, []);

//   useEffect(() => {
//     let result = [...doctors];
    
//     if (search) {
//       const q = search.toLowerCase();
//       result = result.filter(d => 
//         d.name?.toLowerCase().includes(q) ||
//         d.specialization?.toLowerCase().includes(q) ||
//         d.hospital?.toLowerCase().includes(q)
//       );
//     }
    
//     if (specialization !== "All Specializations") {
//       result = result.filter(d => d.specialization?.toLowerCase().includes(specialization.toLowerCase()));
//     }
    
//     setFilteredDoctors(result);
//   }, [search, specialization, doctors]);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center min-h-[400px]">
//         <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-600" />
//       </div>
//     );
//   }

//   return (
//     <div data-testid="doctors-page">
//       {/* Hero Section */}
//       <section className="bg-gradient-to-br from-orange-50 to-white py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-12">
//             <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">
//               <Stethoscope className="h-3 w-3 mr-1" /> Expert Medical Team
//             </Badge>
//             <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mb-4">
//               Our <span className="text-orange-600">Doctors</span>
//             </h1>
//             <p className="text-slate-500 max-w-2xl mx-auto">
//               Meet our team of world-renowned medical specialists with decades of experience and international training.
//             </p>
//           </div>

//           {/* Search & Filter */}
//           <div className="flex flex-col md:flex-row gap-4 max-w-2xl mx-auto mb-8">
//             <div className="relative flex-1">
//               <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
//               <Input
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 placeholder="Search doctors by name, specialization..."
//                 className="pl-10"
//                 data-testid="doctor-search"
//               />
//             </div>
//             <Select value={specialization} onValueChange={setSpecialization}>
//               <SelectTrigger className="w-full md:w-48">
//                 <SelectValue />
//               </SelectTrigger>
//               <SelectContent>
//                 {SPECIALIZATIONS.map(s => (
//                   <SelectItem key={s} value={s}>{s}</SelectItem>
//                 ))}
//               </SelectContent>
//             </Select>
//           </div>
//         </div>
//       </section>

//       {/* Doctors Grid */}
//       <section className="py-12 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           {filteredDoctors.length > 0 ? (
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//               {filteredDoctors.map((doctor) => (
//                 <Card 
//                   key={doctor.id} 
//                   className="bg-white rounded-2xl border border-slate-100 overflow-hidden hover:shadow-lg transition-shadow cursor-pointer"
//                   onClick={() => setSelectedDoctor(doctor)}
//                   data-testid={`doctor-card-${doctor.id}`}
//                 >
//                   <div className="h-48 bg-slate-100 relative">
//                     {doctor.image_url ? (
//                       <img src={doctor.image_url} alt={doctor.name} className="w-full h-full object-cover" />
//                     ) : (
//                       <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-orange-100 to-orange-50">
//                         <Stethoscope className="h-16 w-16 text-orange-300" />
//                       </div>
//                     )}
//                     {doctor.featured && (
//                       <Badge className="absolute top-3 left-3 bg-orange-600 text-white">Featured</Badge>
//                     )}
//                   </div>
//                   <div className="p-5">
//                     <h3 className="font-heading text-lg font-semibold text-slate-900 mb-1">{doctor.name}</h3>
//                     <p className="text-sm text-orange-600 font-medium mb-2">{doctor.designation}</p>
//                     <p className="text-xs text-slate-500 mb-3">{doctor.specialization}</p>
//                     <div className="flex items-center gap-2 text-xs text-slate-400 mb-3">
//                       <Building2 className="h-3 w-3" />
//                       <span>{doctor.hospital || "Partner Hospital"}</span>
//                     </div>
//                     <div className="flex items-center gap-4 text-xs text-slate-500">
//                       <span className="flex items-center gap-1">
//                         <Clock className="h-3 w-3 text-orange-500" />
//                         {doctor.experience_years}+ years
//                       </span>
//                       <span className="flex items-center gap-1">
//                         <Globe className="h-3 w-3 text-orange-500" />
//                         {doctor.languages?.split(',')[0] || "English"}
//                       </span>
//                     </div>
//                   </div>
//                 </Card>
//               ))}
//             </div>
//           ) : (
//             <div className="text-center py-16">
//               <Stethoscope className="h-12 w-12 text-slate-300 mx-auto mb-4" />
//               <p className="text-slate-500">No doctors found matching your criteria</p>
//               <Button 
//                 variant="outline" 
//                 className="mt-4"
//                 onClick={() => { setSearch(""); setSpecialization("All Specializations"); }}
//               >
//                 Clear Filters
//               </Button>
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Doctor Detail Modal */}
//       {selectedDoctor && (
//         <Dialog open={!!selectedDoctor} onOpenChange={() => setSelectedDoctor(null)}>
//           <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
//             <DialogHeader>
//               <DialogTitle className="sr-only">{selectedDoctor.name}</DialogTitle>
//             </DialogHeader>
//             <div className="grid md:grid-cols-2 gap-6">
//               <div>
//                 <div className="rounded-xl overflow-hidden bg-slate-100 h-64">
//                   {selectedDoctor.image_url ? (
//                     <img src={selectedDoctor.image_url} alt={selectedDoctor.name} className="w-full h-full object-cover" />
//                   ) : (
//                     <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-orange-100 to-orange-50">
//                       <Stethoscope className="h-20 w-20 text-orange-300" />
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div>
//                 <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-1">{selectedDoctor.name}</h2>
//                 <p className="text-orange-600 font-medium mb-2">{selectedDoctor.designation}</p>
//                 <Badge variant="outline" className="mb-4">{selectedDoctor.specialization}</Badge>
                
//                 <div className="space-y-3 text-sm">
//                   {selectedDoctor.qualifications && (
//                     <div className="flex items-start gap-2">
//                       <Award className="h-4 w-4 text-orange-500 mt-0.5" />
//                       <div>
//                         <p className="text-slate-400 text-xs">Qualifications</p>
//                         <p className="text-slate-700">{selectedDoctor.qualifications}</p>
//                       </div>
//                     </div>
//                   )}
//                   <div className="flex items-start gap-2">
//                     <Clock className="h-4 w-4 text-orange-500 mt-0.5" />
//                     <div>
//                       <p className="text-slate-400 text-xs">Experience</p>
//                       <p className="text-slate-700">{selectedDoctor.experience_years}+ years</p>
//                     </div>
//                   </div>
//                   <div className="flex items-start gap-2">
//                     <Building2 className="h-4 w-4 text-orange-500 mt-0.5" />
//                     <div>
//                       <p className="text-slate-400 text-xs">Hospital</p>
//                       <p className="text-slate-700">{selectedDoctor.hospital || "Partner Hospital"}</p>
//                     </div>
//                   </div>
//                   <div className="flex items-start gap-2">
//                     <Globe className="h-4 w-4 text-orange-500 mt-0.5" />
//                     <div>
//                       <p className="text-slate-400 text-xs">Languages</p>
//                       <p className="text-slate-700">{selectedDoctor.languages}</p>
//                     </div>
//                   </div>
//                   {selectedDoctor.available_days && (
//                     <div className="flex items-start gap-2">
//                       <Calendar className="h-4 w-4 text-orange-500 mt-0.5" />
//                       <div>
//                         <p className="text-slate-400 text-xs">Available</p>
//                         <p className="text-slate-700">{selectedDoctor.available_days}</p>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
            
//             {selectedDoctor.bio && (
//               <div className="mt-4 pt-4 border-t border-slate-100">
//                 <h4 className="font-medium text-slate-900 mb-2">About</h4>
//                 <p className="text-sm text-slate-600">{selectedDoctor.bio}</p>
//               </div>
//             )}
            
//             {selectedDoctor.achievements && (
//               <div className="mt-4 pt-4 border-t border-slate-100">
//                 <h4 className="font-medium text-slate-900 mb-2">Achievements</h4>
//                 <p className="text-sm text-slate-600">{selectedDoctor.achievements}</p>
//               </div>
//             )}
            
//             <div className="flex gap-3 mt-6">
//               <ConsultationModal
//                 trigger={
//                   <Button className="flex-1 bg-orange-600 hover:bg-orange-700">
//                     <Phone className="h-4 w-4 mr-2" /> Book Consultation
//                   </Button>
//                 }
//               />
//               <a href={`https://wa.me/917289007800?text=I'd like to consult with ${selectedDoctor.name}`} target="_blank" rel="noopener noreferrer" className="flex-1">
//                 <Button variant="outline" className="w-full border-green-500 text-green-600 hover:bg-green-50">
//                   WhatsApp
//                 </Button>
//               </a>
//             </div>
//           </DialogContent>
//         </Dialog>
//       )}
//     </div>
//   );
// }


// Doctors Page - Display doctor profiles
// import { useState, useEffect } from "react";
// import { Card } from "@/components/ui/card";
// import { Badge } from "@/components/ui/badge";
// import { Button } from "@/components/ui/button";
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
// import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
// import ConsultationModal from "@/components/ConsultationModal";
// import { Search, X, Stethoscope, Building2, Clock, Globe, Award, Calendar, Phone } from "lucide-react";
// import axios from "axios";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const SPECIALIZATIONS = [
//   "All Specializations",
//   "Cardiology",
//   "Orthopedics",
//   "Oncology",
//   "Neurology",
//   "Transplant",
//   "Dental",
//   "Cosmetic Surgery",
//   "Fertility",
//   "Eye Care",
//   "General Surgery"
// ];

// export default function DoctorsPage() {
//   const [doctors, setDoctors] = useState([]);
//   const [filteredDoctors, setFilteredDoctors] = useState([]);
//   const [search, setSearch] = useState("");
//   const [specialization, setSpecialization] = useState("All Specializations");
//   const [loading, setLoading] = useState(true);
//   const [selectedDoctor, setSelectedDoctor] = useState(null);

//   useEffect(() => {
//     axios.get(`${API}/doctors`)
//       .then(r => {
//         setDoctors(r.data);
//         setFilteredDoctors(r.data);
//       })
//       .catch(console.error)
//       .finally(() => setLoading(false));
//   }, []);

//   useEffect(() => {
//     let result = [...doctors];
    
//     if (search) {
//       const q = search.toLowerCase();
//       result = result.filter(d => 
//         d.name?.toLowerCase().includes(q) ||
//         d.specialization?.toLowerCase().includes(q) ||
//         d.hospital?.toLowerCase().includes(q)
//       );
//     }
    
//     if (specialization !== "All Specializations") {
//       result = result.filter(d => d.specialization?.toLowerCase().includes(specialization.toLowerCase()));
//     }
    
//     setFilteredDoctors(result);
//   }, [search, specialization, doctors]);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center min-h-[400px]">
//         <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-600" />
//       </div>
//     );
//   }

//   return (
//     <div data-testid="doctors-page">
//       {/* Hero Section */}
//       <section className="bg-gradient-to-br from-orange-50 to-white py-10">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-12">
//             <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">
//               <Stethoscope className="h-3 w-3 mr-1" /> Expert Medical Team
//             </Badge>
//             <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mb-4">
//               Our <span className="text-orange-600">Doctors</span>
//             </h1>
//             <p className="text-slate-500 max-w-2xl mx-auto">
//               Meet our team of world-renowned medical specialists with decades of experience and international training.
//             </p>
//           </div>

//           {/* ── Search & Filter ── */}
//           <div className="flex flex-col md:flex-row gap-4 max-w-2xl mx-auto mb-8">

//             {/* ── Search Bar — same style as other pages ── */}
//             <div className="flex items-center bg-white border-2 border-orange-100 focus-within:border-orange-500 rounded-full shadow-md px-5 py-3 transition-all duration-200 flex-1">
//               <Search className="h-5 w-5 text-orange-400 flex-shrink-0 mr-3" />
//               <input
//                 type="text"
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 placeholder="Search doctors by name, specialization..."
//                 className="flex-1 bg-transparent outline-none text-slate-700 text-sm placeholder:text-slate-400"
//                 data-testid="doctor-search"
//               />
//               {search && (
//                 <button
//                   onClick={() => setSearch("")}
//                   className="ml-2 text-slate-400 hover:text-orange-500 transition-colors"
//                   data-testid="doctor-search-clear"
//                 >
//                   <X className="h-4 w-4" />
//                 </button>
//               )}
//             </div>

//             <Select value={specialization} onValueChange={setSpecialization}>
//               <SelectTrigger className="w-full md:w-48 rounded-full border-2 border-orange-100 focus:border-orange-500 shadow-md px-5 py-3 h-auto">
//                 <SelectValue />
//               </SelectTrigger>
//               <SelectContent>
//                 {SPECIALIZATIONS.map(s => (
//                   <SelectItem key={s} value={s}>{s}</SelectItem>
//                 ))}
//               </SelectContent>
//             </Select>

//           </div>

//           {/* Live Result Count */}
//           {search.trim() && (
//             <p className="text-xs text-slate-400 text-center" data-testid="doctor-search-count">
//               {filteredDoctors.length > 0 ? (
//                 <span>
//                   Showing{" "}
//                   <span className="text-orange-500 font-semibold">{filteredDoctors.length}</span>
//                   {" "}doctor{filteredDoctors.length !== 1 ? "s" : ""} for "
//                   <span className="text-slate-600 font-medium">{search}</span>"
//                 </span>
//               ) : (
//                 <span>
//                   No doctors found for "
//                   <span className="text-slate-600 font-medium">{search}</span>"
//                 </span>
//               )}
//             </p>
//           )}

//         </div>
//       </section>

//       {/* Doctors Grid */}
//       <section className="py-12 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           {filteredDoctors.length > 0 ? (
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//               {filteredDoctors.map((doctor) => (
//                 <Card 
//                   key={doctor.id} 
//                   className="bg-white rounded-2xl border border-slate-100 overflow-hidden hover:shadow-lg transition-shadow cursor-pointer"
//                   onClick={() => setSelectedDoctor(doctor)}
//                   data-testid={`doctor-card-${doctor.id}`}
//                 >
//                   <div className="h-48 bg-slate-100 relative">
//                     {doctor.image_url ? (
//                       <img src={doctor.image_url} alt={doctor.name} className="w-full h-full object-cover" />
//                     ) : (
//                       <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-orange-100 to-orange-50">
//                         <Stethoscope className="h-16 w-16 text-orange-300" />
//                       </div>
//                     )}
//                     {doctor.featured && (
//                       <Badge className="absolute top-3 left-3 bg-orange-600 text-white">Featured</Badge>
//                     )}
//                   </div>
//                   <div className="p-5">
//                     <h3 className="font-heading text-lg font-semibold text-slate-900 mb-1">{doctor.name}</h3>
//                     <p className="text-sm text-orange-600 font-medium mb-2">{doctor.designation}</p>
//                     <p className="text-xs text-slate-500 mb-3">{doctor.specialization}</p>
//                     <div className="flex items-center gap-2 text-xs text-slate-400 mb-3">
//                       <Building2 className="h-3 w-3" />
//                       <span>{doctor.hospital || "Partner Hospital"}</span>
//                     </div>
//                     <div className="flex items-center gap-4 text-xs text-slate-500">
//                       <span className="flex items-center gap-1">
//                         <Clock className="h-3 w-3 text-orange-500" />
//                         {doctor.experience_years}+ years
//                       </span>
//                       <span className="flex items-center gap-1">
//                         <Globe className="h-3 w-3 text-orange-500" />
//                         {doctor.languages?.split(',')[0] || "English"}
//                       </span>
//                     </div>
//                   </div>
//                 </Card>
//               ))}
//             </div>
//           ) : (
//             <div className="flex flex-col items-center justify-center py-24 text-center">
//               <div className="w-20 h-20 rounded-full bg-orange-50 flex items-center justify-center mb-6">
//                 <Search className="h-9 w-9 text-orange-300" />
//               </div>
//               <h3 className="text-xl font-semibold text-slate-700 mb-2">No doctors found</h3>
//               <p className="text-slate-400 text-sm max-w-sm mb-6">
//                 We couldn't find any doctors matching "
//                 <span className="text-orange-500 font-medium">{search}</span>
//                 ". Try a different keyword or browse all doctors.
//               </p>
//               <Button
//                 onClick={() => { setSearch(""); setSpecialization("All Specializations"); }}
//                 className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-6"
//               >
//                 Clear Filters
//               </Button>
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Doctor Detail Modal */}
//       {selectedDoctor && (
//         <Dialog open={!!selectedDoctor} onOpenChange={() => setSelectedDoctor(null)}>
//           <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
//             <DialogHeader>
//               <DialogTitle className="sr-only">{selectedDoctor.name}</DialogTitle>
//             </DialogHeader>
//             <div className="grid md:grid-cols-2 gap-6">
//               <div>
//                 <div className="rounded-xl overflow-hidden bg-slate-100 h-64">
//                   {selectedDoctor.image_url ? (
//                     <img src={selectedDoctor.image_url} alt={selectedDoctor.name} className="w-full h-full object-cover" />
//                   ) : (
//                     <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-orange-100 to-orange-50">
//                       <Stethoscope className="h-20 w-20 text-orange-300" />
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div>
//                 <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-1">{selectedDoctor.name}</h2>
//                 <p className="text-orange-600 font-medium mb-2">{selectedDoctor.designation}</p>
//                 <Badge variant="outline" className="mb-4">{selectedDoctor.specialization}</Badge>
                
//                 <div className="space-y-3 text-sm">
//                   {selectedDoctor.qualifications && (
//                     <div className="flex items-start gap-2">
//                       <Award className="h-4 w-4 text-orange-500 mt-0.5" />
//                       <div>
//                         <p className="text-slate-400 text-xs">Qualifications</p>
//                         <p className="text-slate-700">{selectedDoctor.qualifications}</p>
//                       </div>
//                     </div>
//                   )}
//                   <div className="flex items-start gap-2">
//                     <Clock className="h-4 w-4 text-orange-500 mt-0.5" />
//                     <div>
//                       <p className="text-slate-400 text-xs">Experience</p>
//                       <p className="text-slate-700">{selectedDoctor.experience_years}+ years</p>
//                     </div>
//                   </div>
//                   <div className="flex items-start gap-2">
//                     <Building2 className="h-4 w-4 text-orange-500 mt-0.5" />
//                     <div>
//                       <p className="text-slate-400 text-xs">Hospital</p>
//                       <p className="text-slate-700">{selectedDoctor.hospital || "Partner Hospital"}</p>
//                     </div>
//                   </div>
//                   <div className="flex items-start gap-2">
//                     <Globe className="h-4 w-4 text-orange-500 mt-0.5" />
//                     <div>
//                       <p className="text-slate-400 text-xs">Languages</p>
//                       <p className="text-slate-700">{selectedDoctor.languages}</p>
//                     </div>
//                   </div>
//                   {selectedDoctor.available_days && (
//                     <div className="flex items-start gap-2">
//                       <Calendar className="h-4 w-4 text-orange-500 mt-0.5" />
//                       <div>
//                         <p className="text-slate-400 text-xs">Available</p>
//                         <p className="text-slate-700">{selectedDoctor.available_days}</p>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
            
//             {selectedDoctor.bio && (
//               <div className="mt-4 pt-4 border-t border-slate-100">
//                 <h4 className="font-medium text-slate-900 mb-2">About</h4>
//                 <p className="text-sm text-slate-600">{selectedDoctor.bio}</p>
//               </div>
//             )}
            
//             {selectedDoctor.achievements && (
//               <div className="mt-4 pt-4 border-t border-slate-100">
//                 <h4 className="font-medium text-slate-900 mb-2">Achievements</h4>
//                 <p className="text-sm text-slate-600">{selectedDoctor.achievements}</p>
//               </div>
//             )}
            
//             <div className="flex gap-3 mt-6">
//               <ConsultationModal
//                 trigger={
//                   <Button className="flex-1 bg-orange-600 hover:bg-orange-700">
//                     <Phone className="h-4 w-4 mr-2" /> Book Consultation
//                   </Button>
//                 }
//               />
//               <a href={`https://wa.me/917289007800?text=I'd like to consult with ${selectedDoctor.name}`} target="_blank" rel="noopener noreferrer" className="flex-1">
//                 <Button variant="outline" className="w-full border-green-500 text-green-600 hover:bg-green-50">
//                   WhatsApp
//                 </Button>
//               </a>
//             </div>
//           </DialogContent>
//         </Dialog>
//       )}
//     </div>
//   );
// }

// DoctorsPage.jsx
import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import ConsultationModal from "@/components/ConsultationModal";
import { Search, X, Stethoscope, Building2, Clock, Globe, Award, Calendar, Phone } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SPECIALIZATIONS = [
  "All Specializations",
  "Cardiology",
  "Orthopedics",
  "Oncology",
  "Neurology",
  "Transplant",
  "Dental",
  "Cosmetic Surgery",
  "Fertility",
  "Eye Care",
  "General Surgery"
];

export default function DoctorsPage() {
  const [doctors, setDoctors] = useState([]);
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [search, setSearch] = useState("");
  const [specialization, setSpecialization] = useState("All Specializations");
  const [loading, setLoading] = useState(true);
  const [selectedDoctor, setSelectedDoctor] = useState(null);

  useEffect(() => {
    axios.get(`${API}/doctors`)
      .then(r => {
        setDoctors(r.data);
        setFilteredDoctors(r.data);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    let result = [...doctors];
    if (search) {
      const q = search.toLowerCase();
      result = result.filter(d =>
        d.name?.toLowerCase().includes(q) ||
        d.specialization?.toLowerCase().includes(q) ||
        d.hospital?.toLowerCase().includes(q)
      );
    }
    if (specialization !== "All Specializations") {
      result = result.filter(d =>
        d.specialization?.toLowerCase().includes(specialization.toLowerCase())
      );
    }
    setFilteredDoctors(result);
  }, [search, specialization, doctors]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-600" />
      </div>
    );
  }

  return (
    <div data-testid="doctors-page">

      {/* ── Hero + Search Section ── */}
      <section className="bg-gradient-to-br from-orange-50 to-white py-10 md:py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Heading */}
          <div className="text-center mb-10">
            <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">
              <Stethoscope className="h-3 w-3 mr-1" /> Expert Medical Team
            </Badge>
            <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mb-4">
              Our <span className="text-orange-600">Doctors</span>
            </h1>
            <p className="text-base md:text-lg text-slate-500 max-w-2xl mx-auto">
              Meet our team of world-renowned medical specialists with decades of experience and international training.
            </p>
          </div>

          {/* Search + Filter */}
          <div className="max-w-2xl mx-auto">
            <div className="flex flex-col md:flex-row gap-4 mb-3">

              {/* Search Bar */}
              <div className="flex items-center bg-white border-2 border-orange-100 focus-within:border-orange-500 rounded-full shadow-md px-5 py-3 transition-all duration-200 flex-1">
                <Search className="h-5 w-5 text-orange-400 flex-shrink-0 mr-3" />
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search doctors by name, specialization..."
                  className="flex-1 bg-transparent outline-none text-slate-700 text-sm placeholder:text-slate-400"
                  data-testid="doctor-search"
                />
                {search && (
                  <button
                    onClick={() => setSearch("")}
                    className="ml-2 text-slate-400 hover:text-orange-500 transition-colors"
                    data-testid="doctor-search-clear"
                  >
                    <X className="h-4 w-4" />
                  </button>
                )}
              </div>

              {/* Specialization Select */}
              <Select value={specialization} onValueChange={setSpecialization}>
                <SelectTrigger className="w-full md:w-52 rounded-full border-2 border-orange-100 focus:border-orange-500 shadow-md px-5 h-[50px]">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {SPECIALIZATIONS.map(s => (
                    <SelectItem key={s} value={s}>{s}</SelectItem>
                  ))}
                </SelectContent>
              </Select>

            </div>

            {/* Live Result Count */}
            {search.trim() && (
              <p className="text-xs text-slate-400 text-center mt-2" data-testid="doctor-search-count">
                {filteredDoctors.length > 0 ? (
                  <span>
                    Showing{" "}
                    <span className="text-orange-500 font-semibold">{filteredDoctors.length}</span>
                    {" "}doctor{filteredDoctors.length !== 1 ? "s" : ""} for "
                    <span className="text-slate-600 font-medium">{search}</span>"
                  </span>
                ) : (
                  <span>
                    No doctors found for "
                    <span className="text-slate-600 font-medium">{search}</span>"
                  </span>
                )}
              </p>
            )}
          </div>

        </div>
      </section>

      {/* ── Doctors Grid ── */}
      <section className="py-10 md:py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {filteredDoctors.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {filteredDoctors.map((doctor) => (
                <Card
                  key={doctor.id}
                  className="bg-white rounded-2xl border border-slate-100 overflow-hidden hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => setSelectedDoctor(doctor)}
                  data-testid={`doctor-card-${doctor.id}`}
                >
                  <div className="h-48 bg-slate-100 relative">
                    {doctor.image_url ? (
                      <img src={doctor.image_url} alt={doctor.name} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-orange-100 to-orange-50">
                        <Stethoscope className="h-16 w-16 text-orange-300" />
                      </div>
                    )}
                    {doctor.featured && (
                      <Badge className="absolute top-3 left-3 bg-orange-600 text-white">Featured</Badge>
                    )}
                  </div>
                  <div className="p-5">
                    <h3 className="font-heading text-lg font-semibold text-slate-900 mb-1">{doctor.name}</h3>
                    <p className="text-sm text-orange-600 font-medium mb-2">{doctor.designation}</p>
                    <p className="text-xs text-slate-500 mb-3">{doctor.specialization}</p>
                    <div className="flex items-center gap-2 text-xs text-slate-400 mb-3">
                      <Building2 className="h-3 w-3" />
                      <span>{doctor.hospital || "Partner Hospital"}</span>
                    </div>
                    <div className="flex items-center gap-4 text-xs text-slate-500">
                      <span className="flex items-center gap-1">
                        <Clock className="h-3 w-3 text-orange-500" />
                        {doctor.experience_years}+ years
                      </span>
                      <span className="flex items-center gap-1">
                        <Globe className="h-3 w-3 text-orange-500" />
                        {doctor.languages?.split(",")[0] || "English"}
                      </span>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-24 text-center">
              <div className="w-20 h-20 rounded-full bg-orange-50 flex items-center justify-center mb-6">
                <Search className="h-9 w-9 text-orange-300" />
              </div>
              <h3 className="text-xl font-semibold text-slate-700 mb-2">No doctors found</h3>
              <p className="text-slate-400 text-sm max-w-sm mb-6">
                We couldn't find any doctors matching "
                <span className="text-orange-500 font-medium">{search}</span>
                ". Try a different keyword or browse all doctors.
              </p>
              <Button
                onClick={() => { setSearch(""); setSpecialization("All Specializations"); }}
                className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-6"
              >
                Clear Filters
              </Button>
            </div>
          )}
        </div>
      </section>

      {/* ── Doctor Detail Modal ── */}
      {selectedDoctor && (
        <Dialog open={!!selectedDoctor} onOpenChange={() => setSelectedDoctor(null)}>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="sr-only">{selectedDoctor.name}</DialogTitle>
            </DialogHeader>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <div className="rounded-xl overflow-hidden bg-slate-100 h-64">
                  {selectedDoctor.image_url ? (
                    <img src={selectedDoctor.image_url} alt={selectedDoctor.name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-orange-100 to-orange-50">
                      <Stethoscope className="h-20 w-20 text-orange-300" />
                    </div>
                  )}
                </div>
              </div>
              <div>
                <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-1">{selectedDoctor.name}</h2>
                <p className="text-orange-600 font-medium mb-2">{selectedDoctor.designation}</p>
                <Badge variant="outline" className="mb-4">{selectedDoctor.specialization}</Badge>
                <div className="space-y-3 text-sm">
                  {selectedDoctor.qualifications && (
                    <div className="flex items-start gap-2">
                      <Award className="h-4 w-4 text-orange-500 mt-0.5" />
                      <div>
                        <p className="text-slate-400 text-xs">Qualifications</p>
                        <p className="text-slate-700">{selectedDoctor.qualifications}</p>
                      </div>
                    </div>
                  )}
                  <div className="flex items-start gap-2">
                    <Clock className="h-4 w-4 text-orange-500 mt-0.5" />
                    <div>
                      <p className="text-slate-400 text-xs">Experience</p>
                      <p className="text-slate-700">{selectedDoctor.experience_years}+ years</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <Building2 className="h-4 w-4 text-orange-500 mt-0.5" />
                    <div>
                      <p className="text-slate-400 text-xs">Hospital</p>
                      <p className="text-slate-700">{selectedDoctor.hospital || "Partner Hospital"}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <Globe className="h-4 w-4 text-orange-500 mt-0.5" />
                    <div>
                      <p className="text-slate-400 text-xs">Languages</p>
                      <p className="text-slate-700">{selectedDoctor.languages}</p>
                    </div>
                  </div>
                  {selectedDoctor.available_days && (
                    <div className="flex items-start gap-2">
                      <Calendar className="h-4 w-4 text-orange-500 mt-0.5" />
                      <div>
                        <p className="text-slate-400 text-xs">Available</p>
                        <p className="text-slate-700">{selectedDoctor.available_days}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {selectedDoctor.bio && (
              <div className="mt-4 pt-4 border-t border-slate-100">
                <h4 className="font-medium text-slate-900 mb-2">About</h4>
                <p className="text-sm text-slate-600">{selectedDoctor.bio}</p>
              </div>
            )}
            {selectedDoctor.achievements && (
              <div className="mt-4 pt-4 border-t border-slate-100">
                <h4 className="font-medium text-slate-900 mb-2">Achievements</h4>
                <p className="text-sm text-slate-600">{selectedDoctor.achievements}</p>
              </div>
            )}

            <div className="flex gap-3 mt-6">
              <ConsultationModal
                trigger={
                  <Button className="flex-1 bg-orange-600 hover:bg-orange-700">
                    <Phone className="h-4 w-4 mr-2" /> Book Consultation
                  </Button>
                }
              />
              <a
                href={`https://wa.me/917289007800?text=I'd like to consult with ${selectedDoctor.name}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1"
              >
                <Button variant="outline" className="w-full border-green-500 text-green-600 hover:bg-green-50">
                  WhatsApp
                </Button>
              </a>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}